const URL_EMOTION_RECOGNITION_MODEL  =
  "https://raw.githubusercontent.com/clementreiffers/emotion-recognition-website/main/resnet50js_ferplus/model.json";

const URL_JS_DELIVR  =
  "https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/";

const URL_GITHUB_CODE_SOURCE =
  "https://github.com/clementreiffers/emotion-recognition-website-react";

export { URL_EMOTION_RECOGNITION_MODEL, URL_JS_DELIVR, URL_GITHUB_CODE_SOURCE };
